// Derives the original-due-date the dialog pre-fills from a ticket's
// payment-terms config. The current Order Detail surface only carries the
// ticket's free-text `payment_terms` string and the order's
// `downpaymentDueDate` (already a wire-formatted ISO). When the structured
// `ticket_payment_schedule` rows are seeded, this helper grows a second
// arm that walks the schedule and applies `trigger_event` + `offset_days`.

export interface PaymentTermsContext {
  readonly downpaymentDueDate: string | null;
}

const TODAY_FALLBACK = (): Date => new Date();

export function deriveOriginalDueDate(
  ctx: PaymentTermsContext,
  now: () => Date = TODAY_FALLBACK,
): string {
  if (ctx.downpaymentDueDate !== null) {
    return ctx.downpaymentDueDate.slice(0, 10);
  }
  const d = now();
  const yyyy = String(d.getUTCFullYear());
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
